export enum SENTIMENT_FIELD {
  WeeklyPositiveSentimentReviewVolume = 'weeklyPositiveSentimentReviewVolume',
  WeeklyNeutralSentimentReviewVolume = 'weeklyNeutralSentimentReviewVolume',
  WeeklyNegativeSentimentReviewVolume = 'weeklyNegativeSentimentReviewVolume',
  WeeklyReviewVolume = 'weeklyReviewVolume'
}

export enum LIFETIME_SENTIMENT_FIELD {
  LifetimePositiveSentimentReviewVolume = 'lifetimePositiveSentimentReviewVolume',
  LifetimeNeutralSentimentReviewVolume = 'lifetimeNeutralSentimentReviewVolume',
  LifetimeNegativeSentimentReviewVolume = 'lifetimeNegativeSentimentReviewVolume',
  LifetimeReviewVolume = 'lifetimeReviewVolume'
}

/**
 * Enum representing the sentiment of a review.
 * 1 = Positive.
 * 0 = Neutral.
 * -1 = Negative.
 */
export enum REVIEW_SENTIMENT_ENUM {
  POSITIVE = 1,
  NEUTRAL = 0,
  NEGATIVE = -1
}

export const SENTIMENT_ENUM_TO_STRING = {
  [REVIEW_SENTIMENT_ENUM.NEGATIVE]: 'negative',
  [REVIEW_SENTIMENT_ENUM.NEUTRAL]: 'neutral',
  [REVIEW_SENTIMENT_ENUM.POSITIVE]: 'positive'
};
